import noop from "lodash/noop";
import React, { FunctionComponent, ReactElement, useCallback } from "react";
import "./style.scss";

interface Props {
  checked?: boolean;
  disabled?: boolean;
  name: string;
  onChange: (name: string) => void;
  value: string;
}

const CartRadioInput: FunctionComponent<Props> = ({
  value,
  name,
  onChange = noop,
  checked = false,
  disabled = false,
}): ReactElement => {
  const handleChange = useCallback(() => onChange(value), [onChange, value]);

  return (
    <label className="CartRadioInput">
      <input
        checked={checked}
        className="CartRadioInput-input"
        disabled={disabled}
        id={value}
        name={name}
        onChange={handleChange}
        type="radio"
        value={value}
      />
      <span className="CartRadioInput-checkmark" />
    </label>
  );
};

export default React.memo(CartRadioInput);
